import { createMutationAtom } from 'atoms/create-resource-atom';
import { Notifications } from 'types/api-responses';

const runMutationAtom = createMutationAtom<
  { notifications: Notifications },
  'entityDeduplication'
>();

export { runMutationAtom };
